import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';
import USERS from 'constants/users';
import CaseLabel from 'containers/CaseCave/CaseDetails/CaseLabels/CaseLabel';
import { Typography } from 'ravenjs/lib';

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;
    flex-wrap: wrap;
    row-gap: 4px;
`;

const PrimaryAccountNameMCACell = ({ row }) => {
    const { companyName, isPrimaryCompany } = row || {};

    return (
        <NameWrapper>
            <Typography style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: '14px' }}>
                {companyName}
            </Typography>
            {isPrimaryCompany && (
                <CaseLabel
                    title={USERS.SWITCH_ACCOUNT_MODAL.PRIMARY_ACCOUNT}
                    color={DEFAULT_COLORS.GREEN_3}
                    fontColor={DEFAULT_COLORS.WHITE}
                    fontSize="12px"
                    style={{
                        fontWeight: '500',
                        fontFamily: 'Roboto',
                        padding: '6px 12px',
                        height: '30px',
                        borderRadius: '50px',
                        marginRight: '0px',
                        minWidth: 'fit-content',
                    }}
                />
            )}
        </NameWrapper>
    );
};

PrimaryAccountNameMCACell.propTypes = {
    row: PropTypes.object,
};

PrimaryAccountNameMCACell.defaultProps = {
    row: {},
};

export default PrimaryAccountNameMCACell;
